import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import CreateIcon from "@material-ui/icons/Create";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { ROUTES } from "@constants";
import "./css/cartSummary.scss";
import { useHistory } from "react-router-dom";
import { ICart } from "@features/cart/ICart";
import { fixUrlLanguage } from "@utils/changeLanguage";

interface IParams {
    editable: boolean;
    userCart: ICart | undefined;
}

export const CartSummary = (props: IParams) => {
    const { editable, userCart } = props;
    const { t } = useTranslation(["summary", "cart", "common"]);
    const { push } = useHistory();

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <Fragment>
            {userCart && (
                <Fragment>
                    <CardContent className="cart-summary">
                        <Grid alignItems="center" container>
                            <Grid item xs={editable ? 10 : 12}>
                                <Typography align={editable ? "left" : "center"} color="inherit" variant="h2">
                                    {t("summary:orderSummary")}
                                </Typography>
                            </Grid>
                            {editable && (
                                <Grid className="cart-summary__edit" item xs={2}>
                                    <IconButton
                                        aria-label="Create"
                                        color="inherit"
                                        onClick={() => push(fixUrlLanguage(ROUTES.CART_PAGE_URL_EN))}
                                    >
                                        <CreateIcon />
                                    </IconButton>
                                </Grid>
                            )}
                        </Grid>
                    </CardContent>
                    <section className="cart-summary-content">
                        <Typography align="center" color="secondary" gutterBottom variant="h5">
                            {t("summary:orderDetails")}
                        </Typography>
                        <Table className="cart-summary-content__table">
                            <TableBody>
                                {userCart.offers.map((offer) => (
                                    <TableRow key={offer.offerId}>
                                        <TableCell>
                                            <Typography variant="body1">{offer.baseOffer.description}</Typography>
                                            {offer.port && (
                                                <Typography variant="body1">
                                                    {offer.port.msisdn}
                                                    {/* -{" "} */}
                                                    {/* {format(new Date(offer.port.portStartDateTime), "dd/MM/yyyy")} */}
                                                </Typography>
                                            )}
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography component="span" variant="body1">
                                                {t("common:price", { price: offer.recurringChargeAmount })}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                <TableRow selected>
                                    <TableCell variant="footer">
                                        <Typography variant="body1">{t("summary:totalMonthly")}</Typography>
                                    </TableCell>
                                    <TableCell align="right" variant="footer">
                                        <Typography variant="body1">
                                            {t("common:price", { price: userCart.recurringChargeAmount })}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </section>
                    <section className="cart-summary-once">
                        <Typography align="center" color="secondary" gutterBottom variant="h5">
                            {t("summary:onceOff")}
                        </Typography>
                        <Table>
                            <TableBody>
                                {userCart.offers.map((offer) => (
                                    <TableRow key={offer.offerId}>
                                        <TableCell>
                                            <div>
                                                <Typography component="span" variant="body1">
                                                    {t("summary:activationCost")}
                                                </Typography>
                                                {offer.port && (
                                                    <Typography variant="body1">
                                                        {offer.port.msisdn}
                                                        {/* -{" "} */}
                                                        {/* {format(new Date(offer.port.portStartDateTime), "dd/MM/yyyy")} */}
                                                    </Typography>
                                                )}
                                            </div>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Typography component="span" variant="body1">
                                                {t("common:price", { price: offer.upFrontChargeAmount })}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                <TableRow selected>
                                    <TableCell variant="footer">
                                        <Typography component="span" variant="body1">
                                            {t("summary:totalActivation")}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="right" variant="footer">
                                        <Typography component="span" variant="body1">
                                            {t("common:price", { price: userCart.upFrontChargeAmount })}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        <Typography className="cart-summary-once__info" color="secondary" variant="body1">
                            {t("summary:cartSummaryNote")}
                        </Typography>
                    </section>
                </Fragment>
            )}
        </Fragment>
    );
};
